import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { LoginPage } from '../../pages/auth/LoginPage';
import { AccountLockedPage } from '../../pages/auth/AccountLockedPage';
import { Setup2FAPage } from '../../pages/auth/Setup2FAPage';
export const ProtectedRoute = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const {
    isAuthenticated,
    isAccountLocked,
    is2FAVerified
  } = useAuth();
  if (isAccountLocked) {
    return <AccountLockedPage data-id="element-58" />;
  }
  if (!isAuthenticated) {
    return <LoginPage data-id="element-59" />;
  } else if (!is2FAVerified) {
    return <Setup2FAPage data-id="element-60" />;
  }
  return <>{children}</>;
};